"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const type_1 = require("./type");
class AbstractTokenizer {
    constructor() {
        this.position = 0;
        this.numBuffer = Buffer.alloc(4);
    }
    async readToken(token, position = null, maybeless) {
        const buffer = Buffer.alloc(token.len);
        const len = await this.readBuffer(buffer, 0, token.len, position);
        if (!maybeless && len < token.len)
            throw new Error(type_1.endOfFile);
        return token.get(buffer, 0);
    }
    async peekToken(token, position = this.position, maybeless) {
        const buffer = Buffer.alloc(token.len);
        const len = await this.peekBuffer(buffer, 0, token.len, position);
        if (!maybeless && len < token.len)
            throw new Error(type_1.endOfFile);
        return token.get(buffer, 0);
    }
    async readNumber(token) {
        const len = await this.readBuffer(this.numBuffer, 0, token.len, null);
        if (len < token.len)
            throw new Error(type_1.endOfFile);
        return token.get(this.numBuffer, 0);
    }
    async peekNumber(token) {
        const len = await this.peekBuffer(this.numBuffer, 0, token.len);
        if (len < token.len)
            throw new Error(type_1.endOfFile);
        return token.get(this.numBuffer, 0);
    }
    async close() {
        // empty
    }
}
exports.AbstractTokenizer = AbstractTokenizer;
